const firebaseConfig = {
    apiKey: "AIzaSyA8Gk5O1CiQwu4EjrtltC5x3vBjbjzWaQY",
    authDomain: "mamar-dukan.firebaseapp.com",
    projectId: "mamar-dukan",
    storageBucket: "mamar-dukan.appspot.com",
    messagingSenderId: "644529764867",
    appId: "1:644529764867:web:117dd35d673f9ca5afec36"
  };

export default firebaseConfig;